import { useQuery } from '@tanstack/react-query';

import DateUtils, { DateType } from '../../utils/DateUtils';
import { API_CONFIG } from '../config/env';
import { CommissionControllerApi, StimBrowsingControllerApi } from '../generated/stim/api';
import {
  QK_STIM_COMMISSION_STATUS,
  QK_STIM_PRESCRIPTION_LIST,
  QK_STIM_SESSION_LIST,
  QK_STIM_SUBJECTS_LIST,
} from '../query-keys';

// 타입 re-export
export type { Browsing as StimPatient } from '../generated/stim/model/browsing';
export { BrowsingSexEnum as StimPatientGender } from '../generated/stim/model/browsing';
export type { OrganizationCommissionStatus as StimCommissionStatus } from '../generated/stim/model/organization-commission-status';
export type { PrescriptionBrowsing as StimLatestPrescription } from '../generated/stim/model/prescription-browsing';
export { PrescriptionBrowsingStatusEnum as StimPrescriptionStatus } from '../generated/stim/model/prescription-browsing';
export type { PrescriptionEntity as StimPrescription } from '../generated/stim/model/prescription-entity';
export { PrescriptionEntityTypeEnum as StimPrescriptionType } from '../generated/stim/model/prescription-entity';
export type { StimSessionEntity as StimSession } from '../generated/stim/model/stim-session-entity';
export { StimSessionEntityResultEnum as StimSessionResult } from '../generated/stim/model/stim-session-entity';

const minddStimURL = API_CONFIG.STIM_URL;
const stimBrowsingControllerApi = new StimBrowsingControllerApi(undefined, minddStimURL);
const commissionControllerApi = new CommissionControllerApi(undefined, minddStimURL);

export const useFetchSubjects = () => {
  return useQuery({
    queryKey: [QK_STIM_SUBJECTS_LIST],
    queryFn: () => stimBrowsingControllerApi.getSubjects().then((res) => res.data),
  });
};

export const useFetchPrescriptions = (uuid?: string) => {
  return useQuery({
    queryKey: [QK_STIM_PRESCRIPTION_LIST, uuid],
    queryFn: () =>
      stimBrowsingControllerApi
        .getPrescriptions(uuid!)
        .then((res) => res.data)
        .then((data) =>
          data.sort((a, b) => {
            return DateUtils.compare(b.prescriptionTime, a.prescriptionTime, DateType.LocalDateTime);
          })
        ),
    enabled: !!uuid,
  });
};

export const useFetchStimSessions = (uuid?: string) => {
  return useQuery({
    queryKey: [QK_STIM_SESSION_LIST, uuid],
    queryFn: () =>
      stimBrowsingControllerApi
        .getStimSessions(uuid!)
        .then((res) => res.data)
        .then((data) =>
          data.sort((a, b) => {
            return DateUtils.compare(b.startTime, a.startTime, DateType.LocalDateTime);
          })
        ),
    enabled: !!uuid,
  });
};

export const useFetchOrganizationCommissionStatus = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [QK_STIM_COMMISSION_STATUS],
    queryFn: () => commissionControllerApi.getOrganizationCommissionStatus().then((res) => res.data),
    enabled,
  });
};
